import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { AccountSubformVariant } from 'src/app/models/accountSettings.model';

@Component({
    standalone: false,
    selector: 'app-account-subform-shell',
    templateUrl: './account-subform-shell.component.html',
    styleUrls: ['./account-subform-shell.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AccountSubformShellComponent {
    @Input() crumb = '';
    @Input() title = '';
    @Input() titleId = '';
    @Input() variant: AccountSubformVariant = 'compact';
    @Output() back = new EventEmitter<void>();
}
